export enum ApiStatus {
  NONE,
  LOADING,
  SUCCESS,
  ERROR
}

export enum UserLoginStatus {
  LOGIN_PROGRESS = "LOGIN_PROGRESS",
  LOGGED_IN = "LOGGED_IN",
  LOGGED_OUT = "LOGGED_OUT"
}
